import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Card } from '../../../common/Card';
import { getServiceRoute } from '../../../../services/serviceConfig';
import styles from './InBCard.module.css';

export const InBCard = ({ name, value, serviceKey, icon, onCloseSidebar }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    // Close sidebar before navigation
    if (onCloseSidebar) {
      onCloseSidebar();
    }

    const route = getServiceRoute(serviceKey);
    if (route) {
      navigate(route);
    } else {
      console.warn(`No route found for service: ${serviceKey}`);
    }
  };

  return (
    <Card className={`${styles.card} ${styles.clickable}`} onClick={handleClick}>
      <div className={styles.content}>
        <div className={styles.info}>
          <h1 className={styles.name}>{name}</h1>
          <p className={styles.value}>
            {value}
          </p>
        </div>
        {/* <div className={styles.icon}>{icon}</div> */}
        <div className={styles.arrow}>→</div>
      </div>
    </Card>
  );
};

InBCard.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  serviceKey: PropTypes.string.isRequired,
  icon: PropTypes.node,
  onCloseSidebar: PropTypes.func
};
